import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useAppAuth } from '~/hooks/appAuth';
import { useCart } from '~/hooks/cart';
import { useSettings } from '~/hooks/settings';

import Login from '~/pages/app/Login';

import { MenuItem, MenuCenter, Badge, TopButton } from './styles';

const Menu: React.FC = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { user } = useAppAuth();
  const { company } = useSettings();
  const { products } = useCart();
  const [page, setPage] = useState('home');
  const [showAuth, setShowAuth] = useState(false);

  useEffect(() => {
    // if (history.location.pathname.includes('home')) setPage('home');
    if (history.location.pathname.includes('about')) setPage('info');
    if (history.location.pathname.includes('cart')) setPage('cart');
    if (history.location.pathname.includes('orders')) setPage('orders');
    if (history.location.pathname.includes('checkout')) setPage('');
  }, [history]);

  const handleNavigateMenuPrivate = useCallback(
    (page_name: string) => {
      if (!user || !user.uid) {
        setShowAuth(true);
        return;
      }

      setPage(page_name);
      document.getElementById(page_name)?.click();
      // history.push(`${new_page}${search}`);
    },
    [user],
  );

  const handleNavigateMenu = useCallback((page_name: string) => {
    setPage(page_name);
  }, []);

  const isHome = useMemo(() => {
    return page === 'home' ? 1 : 0;
  }, [page]);

  const isOrders = useMemo(() => {
    return page === 'orders' ? 1 : 0;
  }, [page]);

  const isCart = useMemo(() => {
    return page === 'cart' ? 1 : 0;
  }, [page]);

  const isInfo = useMemo(() => {
    return page === 'info' ? 1 : 0;
  }, [page]);

  return (
    <>
      {showAuth && <Login onClose={() => setShowAuth(false)} />}

      <TopButton id="top-button" style={{ background: company.app_color }}>
        <i className="bi bi-arrow-up" />
      </TopButton>

      {user && user.uid && (
        <div style={{ display: 'none' }}>
          <Link id="checkout" to={`/${company.app_domain}/checkout${search}`} />
          <Link id="orders" to={`/${company.app_domain}/orders${search}`} />
        </div>
      )}

      <footer className="footer">
        <div className="container">
          <ul className="nav nav-pills nav-justified">
            <li className="nav-item">
              <MenuItem
                to={`${search ? `/${company.app_domain}/${search}` : `/${company.app_domain}`}`}
                className={`nav-link ${page === 'home' && 'active'}`}
                active={isHome}
                color={company.app_color}
                onClick={() => {
                  handleNavigateMenu('home');
                }}
              >
                <span>
                  <i className="nav-icon bi bi-search" />
                  <span className="nav-text">Home</span>
                </span>
              </MenuItem>
            </li>
            <li className="nav-item">
              <MenuItem
                to={`/${company.app_domain}/about${search}`}
                className={`nav-link ${page === 'info' && 'active'}`}
                active={isInfo}
                color={company.app_color}
                onClick={() => {
                  handleNavigateMenu('info');
                }}
              >
                <span>
                  <i className="nav-icon bi bi-shop" />
                  <span className="nav-text">Style</span>
                </span>
              </MenuItem>
            </li>
            <li className="nav-item center-item">
              <MenuCenter
                to={`/${company.app_domain}/cart${search}`}
                className={`nav-link ${page === 'cart' && 'active'}`}
                active={isCart}
                color={company.app_color}
                onClick={() => {
                  handleNavigateMenu('cart');
                }}
              >
                <span>
                  <i className="nav-icon bi bi-cart" />
                  <span className="nav-text">Cart</span>
                  {products.length > 0 && (
                    <Badge className="countercart">{products.length}</Badge>
                  )}
                </span>
              </MenuCenter>
            </li>
            <li className="nav-item">
              <MenuItem
                to="#"
                className={`nav-link ${page === 'orders' && 'active'}`}
                active={isOrders}
                color={company.app_color}
                onClick={event => {
                  event.preventDefault();
                  handleNavigateMenuPrivate('orders');
                }}
              >
                <span>
                  <i className="nav-icon bi bi-receipt" />
                  <span className="nav-text">Pedidos</span>
                </span>
              </MenuItem>
            </li>
            <li className="nav-item">
              <MenuItem
                to="#"
                className="nav-link"
                active={0}
                color={company.app_color}
                onClick={event => {
                  event.preventDefault();
                  // handleNavigateMenuPrivate('profile', `/${company.app_domain}/profile`);
                  // suporte / entre em contato
                  const URL = `https://api.whatsapp.com/send?phone=55${company.phone}&text=`;
                  window.open(URL, '_blank');
                }}
              >
                <span>
                  <i className="nav-icon bi bi-chat-right-dots" />
                  {/* <span className="nav-text">Style</span> */}
                </span>
              </MenuItem>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default Menu;
